import { i18n } from '@/assets/translations';

type AppContact = Readonly<{
  address: string;
  email: string;
  bknJewelryEmail: string;
  instagramLink: string;
  linkedinLink: string;
  phone: string;
  whatsAppNumber: string;
}>;

export const appContact: AppContact = Object.freeze({
  get address(): string {
    return i18n.global.t('app.location');
  },
  email: 'brokn@brokn.ch',
  bknJewelryEmail: 'laure.monge@bkn-jewelry.ch',
  instagramLink: 'https://www.instagram.com/broknjewelry/',
  linkedinLink: 'https://www.linkedin.com/company/brokn-jewelry',
  phone: '+41 079 484 37 97',
  // Meme numero, au format attendu par wa.me : indicatif pays sans « + »
  // et sans le 0 national, qui ferait echouer le lien.
  whatsAppNumber: '41794843797'
});
